import React, { Component } from 'react'

class WideRoom extends Component {
  render () {
    const { children, delay, isLast } = this.props
    return (
      <div className={`section section--0 animate forward-wide`} style={{transitionDelay: `${delay}s`}}>
        <div className='wall wall--left wall--wide' />
        <div className='wall wall--right wall--wide' />
        <div className={`section section--1 animate ${isLast ? 'last-section' : ''} forward-wide`} style={{transitionDelay: `${delay + 1}s`}}>
          <div className='wall wall--left wall--wide'>
            <div className='wall-end' />
          </div>
          <div className='wall wall--right wall--wide'>
            <div className='wall-end' />
          </div>
          { children }
        </div>
      </div>
    )
  }
}

export default WideRoom



// WEBPACK FOOTER //
// ./src/components/WideRoom.js